<template lang="pug">
  .component-account-status-filter
    AccountStatus(:accountStatus="status", @input="toggle", :statuses="statuses")
</template>

<script>
  import AccountStatus from '../AccountStatus'

  export default {
    name: 'AccontStatusFilter',
    components: {AccountStatus},
    data() {
      return {
        status: {
          document_status: false,
          payment_method: false,
          subscription: false,
        }
      }
    },
    methods: {
      toggle(val) {
        this.status[val] = val === 'document_status' && this.status.document_status !== 'valid' ? 'valid' : !this.status[val]

        const filter = {
          ...this.value,
          payment_method: this.status.payment_method ? 1 : 0,
          document: this.status.document_status ? 1 : 0,
          subscription: this.status.subscription ? 1 : 0,
        }
        this.$emit('input', filter)
      }
    },
    props: {value: {}, statuses: {type: Array, required: true}}
  }
</script>

<style lang="sass">
  .component-account-status-filter
    .stats
      cursor: pointer
</style>



// WEBPACK FOOTER //
// AccontStatusFilter.vue?1dee8c10